module.exports = __webpack_public_path__ + "img/banner.2bb346d1.png";